
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA7cg-fpnG17Q3IN9M1a5vtn09kNnfNid0",
  authDomain: "bouger-plus-eab63.firebaseapp.com",
  projectId: "bouger-plus-eab63",
  storageBucket: "bouger-plus-eab63.firebasestorage.app",
  messagingSenderId: "927988143956",
  appId: "1:927988143956:web:aaf4b9fc602925e5b15ac1",
  measurementId: "G-53S8YG9P2D"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };